module.exports = __webpack_public_path__ + "img/img-declared-oasis-explan.c850d598.jpeg";